(() => {
  if (window.__sharpGlobalUpgrades20260913) return;
  window.__sharpGlobalUpgrades20260913 = true;

  const WOMEN_CAMO_PREVIEW = 'https://cdn.shopify.com/s/files/1/0645/1045/9994/files/sharp-women-outdoor.jpg?v=1789171792';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const cleanText = (value = '') => value.replace(/\s+/g, ' ').trim();

  const preservePreviewTheme = (href) => {
    try {
      const target = new URL(href, window.location.origin);
      const previewThemeId = new URLSearchParams(window.location.search).get('preview_theme_id');
      if (previewThemeId) target.searchParams.set('preview_theme_id', previewThemeId);
      return target.href;
    } catch (error) {
      return href;
    }
  };

  if (window.location.pathname.replace(/\/$/, '') === '/pages/start-a-team-store') {
    window.location.replace(preservePreviewTheme('/collections/all?view=team-stores#start-a-team-store'));
    return;
  }

  const applyWomenCamoPreview = () => {
    const nav = document.querySelector('.header__inline-menu');
    const topList = nav?.querySelector('.list-menu--inline');
    if (!topList) return;

    const womenMenu = [...topList.children]
      .map((item) => item.querySelector('header-menu'))
      .find((menu) => {
        const summary = menu?.querySelector(':scope > details > summary');
        return cleanText(summary?.textContent).toUpperCase().startsWith('WOMEN');
      });

    if (!womenMenu) return;

    womenMenu.querySelectorAll('.sharp-mega-menu__link').forEach((link) => {
      if (cleanText(link.textContent) !== 'Performance Camo Hoodies') return;
      link.dataset.sharpPreview = WOMEN_CAMO_PREVIEW;
      link.dataset.sharpPreviewLabel = 'Performance Camo Hoodies';
      link.dataset.sharpPreviewPosition = '50% 35%';
    });
  };

  const ensureOverscrollEasterEgg = () => {
    if (typeof window.__sharpCrossBrowserEggCleanup === 'function') {
      window.__sharpCrossBrowserEggCleanup();
      window.__sharpCrossBrowserEggCleanup = null;
    }

    const wrapper = document.querySelector('.header-wrapper');
    const header = wrapper?.querySelector('header') || document.querySelector('header.header');
    const logo = header?.querySelector('.header__heading-logo-wrapper, .header__heading-link');
    if (!wrapper || !header || !logo) return;

    let reveal = wrapper.querySelector('.sharp-overscroll-easter-egg');
    if (!reveal) {
      reveal = document.createElement('div');
      reveal.className = 'sharp-overscroll-easter-egg';
      reveal.setAttribute('aria-hidden', 'true');
      reveal.textContent = 'PHILIPPIANS 4:13';
      wrapper.prepend(reveal);
    }

    if (!document.getElementById('sharp-cross-browser-overscroll-style')) {
      const style = document.createElement('style');
      style.id = 'sharp-cross-browser-overscroll-style';
      style.textContent = `
        html.sharp-chrome-easter-egg,
        html.sharp-chrome-easter-egg body {
          overscroll-behavior-y: contain !important;
        }
        .header-wrapper { overflow: visible !important; }
        .sharp-overscroll-easter-egg {
          position: fixed !important;
          top: var(--sharp-egg-top, 0px) !important;
          left: var(--sharp-egg-left, 50%) !important;
          z-index: 5 !important;
          transform: translate(-50%, calc(-10px + var(--sharp-egg-travel, 0px))) !important;
          opacity: var(--sharp-egg-opacity, 0) !important;
          visibility: hidden !important;
          pointer-events: none !important;
          white-space: nowrap !important;
          background: transparent !important;
          font-family: var(--font-heading-family, Arial, sans-serif) !important;
          font-size: 11px !important;
          font-weight: 800 !important;
          line-height: 1 !important;
          letter-spacing: .16em !important;
          text-transform: uppercase !important;
          transition:
            opacity 150ms ease,
            transform 240ms cubic-bezier(.22,.61,.36,1),
            visibility 0s linear 240ms !important;
          will-change: opacity, transform;
        }
        .sharp-overscroll-easter-egg.is-pulling {
          visibility: visible !important;
          transition:
            opacity 90ms linear,
            transform 90ms linear,
            visibility 0s linear 0s !important;
        }
        @media (max-width: 989px) {
          .sharp-overscroll-easter-egg { position: absolute !important; font-size: 10px !important; }
          #Details-menu-drawer-container:not([open]) .sharp-overscroll-easter-egg { visibility:hidden !important; opacity:0 !important; }
        }
        @media (prefers-reduced-motion: reduce) {
          .sharp-overscroll-easter-egg { transition: none !important; }
        }
      `;
      document.head.appendChild(style);
    }

    const ua = navigator.userAgent || '';
    const isChrome = /(Chrome|CriOS)/.test(ua) && !/(Edg|OPR|SamsungBrowser)/.test(ua);
    document.documentElement.classList.toggle('sharp-chrome-easter-egg', isChrome);

    let pull = 0;
    let releaseTimer = 0;
    let wheelTimer = 0;
    let touchStartY = 0;
    let trackingTouch = false;
    const maxPull = 82;
    const mobileEgg = matchMedia('(max-width:989px)');
    const drawer = document.querySelector('#menu-drawer');
    const drawerScroll = drawer?.querySelector('.menu-drawer__navigation-container');
    const drawerIsOpen = () => !!document.querySelector('#Details-menu-drawer-container[open]');
    const canPull = event => !mobileEgg.matches || (drawerIsOpen() && drawer?.contains(event.target) && (!drawerScroll || drawerScroll.scrollTop <= 1));

    const positionReveal = () => {
      const headerRect = header.getBoundingClientRect();
      if(mobileEgg.matches){
        if(drawer && reveal.parentElement!==drawer)drawer.prepend(reveal);
        reveal.style.setProperty('color','var(--sharp-easter-egg-color, #111)','important');
        reveal.style.setProperty('--sharp-egg-left','50%');
        reveal.style.setProperty('--sharp-egg-top','12px');
        return;
      }
      if(reveal.parentElement!==wrapper)wrapper.prepend(reveal);
      const logoRect = logo.getBoundingClientRect();
      reveal.style.setProperty('--sharp-egg-left', `${Math.round(logoRect.left + (logoRect.width / 2))}px`);
      reveal.style.setProperty('--sharp-egg-top', `${Math.round(headerRect.bottom + 6)}px`);
    };

    const renderPull = (distance) => {
      pull = Math.max(0, Math.min(maxPull, distance));
      const progress = Math.min(1, pull / 58);
      reveal.style.setProperty('--sharp-egg-opacity', reducedMotion.matches ? (progress > .35 ? '1' : '0') : String(progress));
      reveal.style.setProperty('--sharp-egg-travel', `${Math.round(progress * 11)}px`);
      if (progress > .015) reveal.classList.add('is-pulling');
    };

    const release = () => {
      window.clearTimeout(releaseTimer);
      reveal.style.setProperty('--sharp-egg-opacity', '0');
      reveal.style.setProperty('--sharp-egg-travel', '0px');
      pull = 0;
      releaseTimer = window.setTimeout(() => reveal.classList.remove('is-pulling'), reducedMotion.matches ? 0 : 250);
    };

    const onWheel = (event) => {
      if (canPull(event) && (mobileEgg.matches || window.scrollY <= 1) && event.deltaY < 0) {
        positionReveal();
        const increment = Math.min(22, Math.max(4, Math.abs(event.deltaY) * .55));
        renderPull(pull + increment);
        window.clearTimeout(wheelTimer);
        wheelTimer = window.setTimeout(release, 115);
      } else if (event.deltaY > 0 && pull > 0) {
        release();
      }
    };

    const onTouchStart = (event) => {
      if (event.touches.length !== 1 || !canPull(event) || (!mobileEgg.matches && window.scrollY > 1)) {
        trackingTouch = false;
        return;
      }
      positionReveal();
      touchStartY = event.touches[0].clientY;
      trackingTouch = true;
    };

    const onTouchMove = (event) => {
      if (!trackingTouch || event.touches.length !== 1) return;
      const delta = event.touches[0].clientY - touchStartY;
      if (delta <= 0 || !canPull(event) || (!mobileEgg.matches && window.scrollY > 1)) {
        if (pull > 0) release();
        return;
      }
      renderPull(delta * .72);
    };

    const onTouchEnd = () => {
      if (!trackingTouch) return;
      trackingTouch = false;
      release();
    };

    const onScroll = () => {
      positionReveal();
      if (window.scrollY > 2 && pull > 0) release();
    };

    const onOrientationChange = () => window.setTimeout(positionReveal, 120);

    positionReveal();
    window.addEventListener('wheel', onWheel, { passive: true });
    window.addEventListener('touchstart', onTouchStart, { passive: true });
    window.addEventListener('touchmove', onTouchMove, { passive: true });
    window.addEventListener('touchend', onTouchEnd, { passive: true });
    window.addEventListener('touchcancel', onTouchEnd, { passive: true });
    window.addEventListener('resize', positionReveal, { passive: true });
    window.addEventListener('orientationchange', onOrientationChange, { passive: true });
    window.addEventListener('scroll', onScroll, { passive: true });

    window.__sharpCrossBrowserEggCleanup = () => {
      window.clearTimeout(releaseTimer);
      window.clearTimeout(wheelTimer);
      window.removeEventListener('wheel', onWheel);
      window.removeEventListener('touchstart', onTouchStart);
      window.removeEventListener('touchmove', onTouchMove);
      window.removeEventListener('touchend', onTouchEnd);
      window.removeEventListener('touchcancel', onTouchEnd);
      window.removeEventListener('resize', positionReveal);
      window.removeEventListener('orientationchange', onOrientationChange);
      window.removeEventListener('scroll', onScroll);
      reveal.classList.remove('is-pulling');
      reveal.style.setProperty('--sharp-egg-opacity', '0');
      reveal.style.setProperty('--sharp-egg-travel', '0px');
    };
  };

  const initHeroSplitNavigation = (root = document) => {
    const heroes = root.matches?.('.sharp-home-hero')
      ? [root]
      : [...root.querySelectorAll('.sharp-home-opening .sharp-home-hero')];

    if (!heroes.length) return;

    if (!document.getElementById('sharp-hero-split-style')) {
      const style = document.createElement('style');
      style.id = 'sharp-hero-split-style';
      style.textContent = `
        @media screen and (min-width: 990px) {
          .sharp-home-stage.is-revealed .sharp-home-hero { cursor: pointer; }
          .sharp-home-stage.is-revealed .sharp-home-hero__actions {
            display: grid !important;
            grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
            align-items: center !important;
            width: 100% !important;
            max-width: none !important;
            gap: 16px !important;
          }
          @keyframes sharpWomenButtonSettle {
            from { transform: translateX(22px); }
            to { transform: translateX(-4px); }
          }
          @keyframes sharpMenButtonSettle {
            from { transform: translateX(-22px); }
            to { transform: translateX(4px); }
          }
          .sharp-home-stage.is-revealed .sharp-home-hero__actions .sharp-home-button--women-target,
          .sharp-home-stage.is-revealed .sharp-home-hero__actions .sharp-home-button--men-target {
            justify-self: center !important;
            transition:
              transform 320ms cubic-bezier(.22,.61,.36,1),
              background-color 180ms ease,
              border-color 180ms ease,
              box-shadow 180ms ease !important;
          }
          .sharp-home-stage.is-revealed .sharp-home-button--women-target {
            transform: translateX(-4px);
            animation: sharpWomenButtonSettle 520ms cubic-bezier(.22,.61,.36,1);
          }
          .sharp-home-stage.is-revealed .sharp-home-button--men-target {
            transform: translateX(4px);
            animation: sharpMenButtonSettle 520ms cubic-bezier(.22,.61,.36,1);
          }
          .sharp-home-stage.is-revealed .sharp-home-hero.is-women-side .sharp-home-button--women-target {
            transform: translateX(-13px) translateY(-1px);
          }
          .sharp-home-stage.is-revealed .sharp-home-hero.is-men-side .sharp-home-button--men-target {
            transform: translateX(13px) translateY(-1px);
          }
          .sharp-home-stage.is-revealed .sharp-home-hero.is-women-side .sharp-home-button--men-target,
          .sharp-home-stage.is-revealed .sharp-home-hero.is-men-side .sharp-home-button--women-target {
            transform: translateX(0);
          }
        }
        @media (prefers-reduced-motion: reduce) {
          .sharp-home-button--women-target,
          .sharp-home-button--men-target {
            animation: none !important;
            transition: none !important;
            transform: none !important;
          }
        }
      `;
      document.head.appendChild(style);
    }

    heroes.forEach((hero) => {
      if (hero.dataset.sharpSplitReady === 'true') return;

      const groups = [...hero.querySelectorAll('.sharp-home-hero__actions')];
      let womenHref = '';
      let menHref = '';

      groups.forEach((group) => {
        const links = [...group.querySelectorAll('a.sharp-home-button')];
        const women = links.find((link) => /shop\s+women/i.test(cleanText(link.textContent)));
        const men = links.find((link) => /shop\s+men/i.test(cleanText(link.textContent)));
        if (!women || !men) return;

        women.classList.add('sharp-home-button--women-target');
        men.classList.add('sharp-home-button--men-target');
        women.classList.add('sharp-home-button--outline');
        men.classList.remove('sharp-home-button--outline');

        group.append(women, men);
        womenHref ||= women.href;
        menHref ||= men.href;
      });

      if (!womenHref || !menHref) return;

      const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
      const clearSide = () => hero.classList.remove('is-women-side', 'is-men-side');
      const setSideFromX = (clientX) => {
        const rect = hero.getBoundingClientRect();
        const womenSide = clientX < rect.left + (rect.width / 2);
        hero.classList.toggle('is-women-side', womenSide);
        hero.classList.toggle('is-men-side', !womenSide);
        return womenSide;
      };

      hero.addEventListener('pointermove', (event) => {
        if (!finePointer.matches) return;
        setSideFromX(event.clientX);
      }, { passive: true });

      hero.addEventListener('pointerleave', clearSide, { passive: true });

      hero.addEventListener('focusin', (event) => {
        if (event.target.closest('.sharp-home-button--women-target')) {
          hero.classList.add('is-women-side');
          hero.classList.remove('is-men-side');
        } else if (event.target.closest('.sharp-home-button--men-target')) {
          hero.classList.add('is-men-side');
          hero.classList.remove('is-women-side');
        }
      });

      hero.addEventListener('focusout', (event) => {
        if (!hero.contains(event.relatedTarget)) clearSide();
      });

      hero.addEventListener('click', (event) => {
        if (event.defaultPrevented || event.button > 0) return;
        if (event.target.closest('a, button, input, select, textarea, label')) return;
        const womenSide = setSideFromX(event.clientX);
        window.location.assign(preservePreviewTheme(womenSide ? womenHref : menHref));
      });

      hero.dataset.sharpSplitReady = 'true';
    });
  };

  const boot = (root = document) => {
    applyWomenCamoPreview();
    initHeroSplitNavigation(root);
  };

  const bootAfterHeader = () => {
    window.requestAnimationFrame(() => {
      boot();
      ensureOverscrollEasterEgg();
      window.setTimeout(applyWomenCamoPreview, 180);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAfterHeader, { once: true });
  } else {
    bootAfterHeader();
  }

  document.addEventListener('shopify:section:load', (event) => {
    window.requestAnimationFrame(() => {
      boot(event.target);
      applyWomenCamoPreview();
      window.setTimeout(ensureOverscrollEasterEgg, 0);
    });
  });
})();